export default {"src":"/_next/static/media/Royal.cfec129e.svg","height":250,"width":390,"blurWidth":0,"blurHeight":0};